var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#ffa000",
        version: "1.1",
        id: "Capa_1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        width: "204px",
        height: "204px",
        viewBox: "0 0 45.854 45.854",
        "xml:space": "preserve",
        stroke: "#ffa000",
      },
    },
    [
      _c("g", { attrs: { id: "SVGRepo_bgCarrier", "stroke-width": "0" } }),
      _c("g", {
        attrs: {
          id: "SVGRepo_tracerCarrier",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          stroke: "#CCCCCC",
          "stroke-width": "0.091708",
        },
      }),
      _c("g", { attrs: { id: "SVGRepo_iconCarrier" } }, [
        _c("g", [
          _c("path", {
            attrs: {
              d: "M31.751,26.057l-3.572-0.894c1.507-1.339,2.736-3.181,3.559-5.2c1.152-0.255,2.209-1.214,2.383-3.327 c0.164-1.99-0.444-2.877-1.26-3.264c-0.01-0.237-0.021-0.469-0.035-0.696c1.049-5.812-3.103-7.843-3.426-7.941 c-0.541-0.822-4.207-5.821-10.858-1.763c-0.974,0.594-2.519,1.764-3.344,2.942c-0.992,1.246-1.713,3.049-2.009,5.655 c-0.205,0.022-0.409,0.054-0.611,0.1c-0.054-1.279,0.017-5.048,2.405-7.728c1.766-1.981,4.448-2.986,7.968-2.986 c3.526,0,6.263,1.013,8.135,3.009c3.075,3.28,2.797,8.175,2.794,8.224c-0.018,0.262,0.182,0.489,0.443,0.506 c0.012,0.001,0.021,0.001,0.033,0.001c0.248,0,0.457-0.193,0.475-0.445c0.015-0.217,0.312-5.345-3.045-8.933 C29.727,1.116,26.754,0,22.95,0c-3.808,0-6.73,1.114-8.686,3.312c-2.859,3.213-2.706,7.66-2.625,8.695 c-1.113,0.595-1.917,1.89-1.689,4.662c0.301,3.653,2.422,4.926,4.428,4.926c0.39,0,0.734-0.084,1.038-0.239 c1.148,0.743,2.991,1.387,5.944,1.507c0.29,0.436,0.896,0.735,1.6,0.735c0.982,0,1.779-0.586,1.779-1.309 c0-0.723-0.797-1.309-1.779-1.309c-0.801,0-1.478,0.389-1.701,0.924c-1.937-0.092-3.324-0.421-4.315-0.836 c-1.353-1.819-1.996-4.907-1.996-6.671c0-0.653,0.021-1.26,0.059-1.825c6.256,0.21,9.975-2.319,12.007-4.516 c2.617,2.608,3.548,6.138,3.858,7.825c-0.606,4.628-3.906,9.54-7.912,9.54c-1.723,0-3.316-0.909-4.62-2.313 c-1.332-0.278-2.441-0.713-3.323-1.303c0.72,1.287,1.614,2.438,2.645,3.352l-3.58,0.898c-4.889,1.225-8.28,5.598-8.28,10.637v6.033 c0,1.711,1.347,3.129,3.058,3.129h28.09c1.711,0,3.102-1.418,3.102-3.129v-6.033C40.053,31.654,36.64,27.279,31.751,26.057z M30.272,27.652l-4.65,3.183l-1.416-3.622c0.64-0.12,1.259-0.33,1.853-0.617L30.272,27.652z M19.786,26.589 c0.583,0.28,1.194,0.488,1.827,0.61l-1.422,3.637l-4.651-3.184L19.786,26.589z M18.753,43.896h-5.352v-2.533 c0-0.264-0.211-0.477-0.475-0.477c-0.263,0-0.475,0.213-0.475,0.477v2.533h-3.59c-0.66,0-1.159-0.512-1.159-1.172v-6.031 c0-4.088,2.702-7.646,6.624-8.73l5.872,4.025c0.06,0.615,0.572,1.119,1.229,1.137L18.753,43.896z M22.149,28.463l0.446-1.145 c0.121,0.006,0.542,0.008,0.631,0.004l0.445,1.141H22.149z M38.153,42.725c0,0.66-0.543,1.172-1.203,1.172h-3.605v-2.533 c0-0.264-0.211-0.477-0.475-0.477s-0.476,0.213-0.476,0.477v2.533h-5.343l-2.674-10.771c0.652-0.017,1.162-0.515,1.229-1.123 l5.9-4.039c3.922,1.083,6.645,4.642,6.645,8.729v6.031H38.153z",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }